// ** Initial State
const initialState = {
  CSSWOList: [],
  loading_WOList: false,
  error_WOList: '',

  CSSInoviceList: [],
  loading_InoviceList: false,
  error_InoviceList: '',

  CSSCurrentList:[],
  loading_CurrentList: false,
  error_CurrentList: '',

  CSSCurrentList_WithDateRange:[],
  loading_CurrentList_WithDateRange: false,
  error_CurrentList_WithDateRange: '',

  CSSGradationList:[],
  loading_Gradation:false,
  error_Gradation:'',

  CSSNoDueList:[],
  loading_CSSNoDue:false,
  error_CSSNoDue:''
}
// ----------------------Raw Approval Screen-----------------------------
const cssReducer = (state = initialState, action) => {
  switch (action.type) {
     // CSS WorkOrder Details
      case 'CSS_WO_LOADING': {
           return {
               ...state,
               loading_WOList: true,
               error_WOList:''
           }
       }
       case 'CSS_WO_SUCCESS': {
           return {
               ...state,
               CSSWOList: action.data,
               loading_WOList: false
           }
       }
       case 'CSS_WO_ERROR': {
           return {
               ...state,
               loading_WOList: false,
               error_WOList: action.error
           }
       }
     // CSS Invoice Details
     case 'CSS_INVOICE_LOADING': {
           return {
               ...state,
               loading_InoviceList: true,
               error_InoviceList:''
           }
       }
       case 'CSS_INVOICE_SUCCESS': {
           return {
               ...state,
               CSSInoviceList: action.data,
               loading_InoviceList: false
           }
       }
       case 'CSS_INVOICE_ERROR': {
           return {
               ...state,
               loading_InoviceList: false,
               error_InoviceList: action.error
           }
       }
    // CSS Current Status
     case 'CSS_STATUS_LOADING': {
           return {
               ...state,
               loading_CurrentList: true,
               error_CurrentList:''
           }
       }
        // CSS Current Status
     case 'CSS_STATUS_LOADING_WITH_DATERANGE': {
        return {
            ...state,
            loading_CurrentList_WithDateRange: true,
            error_CurrentList_WithDateRange:''
        }
    }
       case 'CSS_STATUS_SUCCESS': {
           return {
               ...state,
               CSSCurrentList: action.data,
               loading_CurrentList: false
           }
       }
       case 'CSS_STATUS_WITH_DATERANGE_SUCCESS': {
        return {
            ...state,
            CSSCurrentList_WithDateRange: action.data,
            loading_CurrentList_WithDateRange: false
        }
    }
       case 'CSS_STATUS_ERROR': {
           return {
               ...state,
               loading_CurrentList: false,
               error_CurrentList: action.error
           }
       }
       case 'CSS_STATUS_WITH_DATERANGE_ERROR': {
        return {
            ...state,
            loading_CurrentList_WithDateRange: false,
            error_CurrentList_WithDateRange: action.error
        }
    }
    // CSS Gradation
     case 'CSS_GRADATION_LOADING': {
           return {
               ...state,
               loading_Gradation: true,
               error_Gradation:''
           }
       }
       case 'CSS_GRADATION_SUCCESS': {
           return {
               ...state,
               CSSGradationList: action.data,
               loading_Gradation: false
           }
       }
       case 'CSS_GRADATION_ERROR': {
           return {
               ...state,
               loading_Gradation: false,
               error_Gradation: action.error
           }
       }

      // CSS CSSNoDue
       case 'CSS_NODUELIST_LOADING': {
           return {
               ...state,
               loading_CSSNoDue: true,
               error_CSSNoDue:''
           }
       }
       case 'CSS_NODUELIST_SUCCESS': {
           return {
               ...state,
               CSSNoDueList: action.data,
               loading_CSSNoDue: false
           }
       }
       case 'CSS_NODUELIST_ERROR': {
           return {
               ...state,
               loading_Gradation: false,
               error_CSSNoDue: action.error
           }
       }

    default:
      return state
  }
}
// ----------------------Raw File Uplaod Screen-----------------------------

export default cssReducer
